export const CF_BASE_URL = process.env.NEXT_PUBLIC_CF_BASE_URL;
export const apiKey = process.env.NEXT_PUBLIC_API_KEY;
export const authDomain = process.env.NEXT_PUBLIC_AUTH_DOMAIN;
export const databaseURL = process.env.NEXT_PUBLIC_DATABASE_URL;
export const projectId = process.env.NEXT_PUBLIC_PROJECT_ID;
export const storageBucket = process.env.NEXT_PUBLIC_STORAGE_BUCKET;
export const messagingSenderId = process.env.NEXT_PUBLIC_SENDER_ID;
export const appId = process.env.NEXT_PUBLIC_APP_ID;
export const measurementId = process.env.NEXT_PUBLIC_MESUREMENT_ID;

export const sentryDSN = process.env.NEXT_PUBLIC_SENTRY_DSN;

export const env = process.env.NEXT_PUBLIC_ENV;

export const firebaseCollections = {
  orders: 'rentals',
  rentals: 'rentals',
  stores: 'stores',
  items: 'items',
  count: 'count',
  employees: 'employees',
  ordersMetaData: 'ordersMetadata',
  ordersCount: 'ordersCount',
};

export const routes = {
  login: '/login',
  home: '/',
  rentals: '/rentals',
  open: '/open',
  closed: '/closed',
  extended: '/extended',
};

export const firebaseApi = {
  stores: {
    fetchAll: '/square/locations',
  },
  employees: {
    fetchStores: (email) => `/employees/status/${email}`,
  },
  orders: {
    parse: '/parse/orders/v2',
    newWT: '/orders/newWT',
  },
  rentals: {
    fetchAll: '/rentals',
  },
};

export const rentalStatuses = {
  new: 'New',
  open: 'Open',
  closed: 'Closed',
  extended: 'Extension',
};
export const itemStatuses = {
  new: 'New',
  extended: 'Extension',
  outWithCustomer: 'Out with Customer',
  damaged: 'Damaged',
  purchased: 'Purchased',
  lost: 'Lost',
  returned: 'Returned',
  droppedOff: 'Dropped Off',
};

export const adjustmentStatuses = {
  return: 'return',
  pickup: 'pickup',
};

export const dateTimeFormat = 'ccc LLL dd, yyyy - h:mm a';
export const dateTimeFormat2 = 'LLL dd, yyyy h:mm a';

export const api = {
  batchInventory: '/inventory/adjustment',
};
export const cardColors = {
  [rentalStatuses.new]: 'yellow',
  [rentalStatuses.open]: 'blue',
  [rentalStatuses.closed]: 'light-grey',
  [rentalStatuses.extended]: 'dark-grey',
};

export const searchOptions = [
  { label: 'By ticket number', value: 'ticketNumber' },
  { label: "By customer's phone", value: 'customerNumberStriped' },
  { label: "By customer's last name", value: 'lastName' },
];

export const searchMap = {
  ticketNumber: 'ticket number',
  customerNumberStriped: `customer's phone`,
  customerName: `customer's name`,
};

export const allStoresOption = { value: 'all', label: 'All Stores' };

export const authErrors = {
  no_stores: 'You have no stores associated to your account',
  not_active: 'This account is not activated',
  unauthorised: 'You are not Authorised',
  google_auth: 'Error retrieving google auth credentials',
  timeout: 'Login excceded timeout threshold',
};

export const AUTH_STATUSES = {
  AUTHENTICATED: "authenticated",
  UNAUTHENTICATED:"unauthenticated",
  LOADING: "loading"
}

export const appVersion = '2.0.5';
